import { useEffect, useState } from "react";

export type AssetLogoTheme = "light" | "dark";

function getThemeFromDocument(): AssetLogoTheme {
  if (typeof document === "undefined") {
    return "light";
  }
  const el = document.documentElement;
  const dataTheme = el.getAttribute("data-theme");
  if (dataTheme === "dark") {
    return "dark";
  }
  if (el.classList.contains("dark")) {
    return "dark";
  }
  return "light";
}

/**
 * Returns the current theme for asset logo display (light/dark).
 * Checks data-theme attribute and .dark class on document.documentElement.
 * Defaults to "light" until app theme is wired.
 */
export function useAssetLogoTheme(): AssetLogoTheme {
  const [theme, setTheme] = useState<AssetLogoTheme>(getThemeFromDocument);

  useEffect(() => {
    const el = document.documentElement;
    const observer = new MutationObserver(() => {
      setTheme(getThemeFromDocument());
    });
    observer.observe(el, {
      attributes: true,
      attributeFilter: ["class", "data-theme"],
    });
    return () => observer.disconnect();
  }, []);

  return theme;
}
